// Confooter.tsx
import React, { useState, useEffect, useMemo } from "react";
import "../styles/index.less";
import { Col, Row, Layout, Typography } from "antd";
import LogoFoot from "../../../assets/images/logo/benchmarklogo.png";
import { contactus_get } from "../../../services/aboutus";
import { useLocation } from "react-router-dom";
import {
  FacebookFilled,
  MailFilled,
  PhoneFilled,
  PushpinFilled,
  TwitterOutlined,
  WechatOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";

type Props = {
  section?: string;
};

const { Footer } = Layout;
const { Title, Text } = Typography;

const Confooter = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [section, setSection] = useState<string | null>(
    localStorage.getItem("confooterSection")
  );
  const [forceUpdate, setForceUpdate] = useState(false);
  const [contactDetail, setContactDetail] = useState<any>(null);


  useEffect(() => {
    setForceUpdate((prev) => !prev);
  }, [i18n.language]);


  useEffect(() => {
    if (section === "confooterSection") {
      const element = document.getElementById("sectioncontact");
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [section, location]);


  useEffect(() => {
    getContactDetail();
  }, []);

  // get contact data
  const getContactDetail = async () => {
    try {
      const res = await contactus_get();
      if (res.data) {
        let rawDetails = JSON.parse(res.data[0].detail);
        setContactDetail(rawDetails);
      }
    } catch (error) {
      console.error("Failed to fetch news details", error);
    }
  };




  return (
    <div id="sectioncontact" className="globalcontainer">
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <div className="task-header">
            <span className="red-bar"></span>
            <p
              className="detail-title"
              style={{
                textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                marginBottom: "0px",
                fontFamily: "IBM Plex Sans Thai",
                padding: "0px",
                color: "#052240",
              }}
            >
              {t("Contact")}
            </p>
          </div>

          <img
            src={LogoFoot}
            alt="LogoFooter"
            className="image-footer"
            style={{ width: "auto", height: "100px" }}
          />

          <div style={{ padding: "30px 0px", fontSize: "16px" }}>
            <p className="footdetail">{t("Build")}</p>
          </div>

          <div
            style={{
              marginBottom: "16px",
              borderRadius: "8px",
              padding: "20px 0px 0px 0px",
            }}
          >
            <Row gutter={[16, 24]} align="middle">
              {contactDetail?.address_show && (
                <>
                  <Col span={2} xs={3} md={4} lg={2}>
                    <PushpinFilled
                      style={{ fontSize: "30px", color: "#BC224A" }}
                    />
                  </Col>
                  <Col span={22} xs={21} md={20} lg={10}>
                    <p className="topicfoot">Address</p>
                    <p className="footdicon">{contactDetail?.address || "112 ถนนพหลโยธิน ตำบลคลองหนึ่ง อำเภอคลองหลวง จังหวัดปทุมธานี 12120" }</p>
                  </Col>
                </>
              )}

              {contactDetail?.Email_show && (
                <>
                  <Col span={2} xs={3} md={4} lg={2}>
                    <MailFilled
                      style={{ fontSize: "30px", color: "#BC224A" }}
                    />
                  </Col>
                  <Col span={22} xs={21} md={20} lg={10}>
                    <p className="topicfoot">E-Mail</p>
                    <p className="footdicon">{contactDetail?.Email || "benchmark@ai.in.th"}</p>
                  </Col>
                </>
              )}
            </Row>
          </div>

          {/* line and tiktok */}
          <div
            style={{
              marginBottom: "16px",
              borderRadius: "8px",
              padding: "0px 0px 20px 0px",
            }}
          >
            <Row gutter={[16, 24]} align="middle">
              {contactDetail?.Line_show && (
                <>
                  <Col span={2} xs={3} md={4} lg={2}>
                    <WechatOutlined
                      style={{ fontSize: "30px", color: "#BC224A" }}
                    />
                  </Col>
                  <Col span={22} xs={21} md={20} lg={10}>
                    <p className="topicfoot">Wechat</p>
                    <p className="footdicon">{contactDetail?.Line || "AI Benchmark"}</p>
                  </Col>
                </>
              )}

              {contactDetail?.Tiktok_show && (
                <>
                  <Col span={2} xs={3} md={4} lg={2}>
                    <TwitterOutlined
                      style={{ fontSize: "30px", color: "#BC224A" }}
                    />
                  </Col>
                  <Col span={22} xs={21} md={20} lg={10}>
                    <p className="topicfoot">X</p>
                    <p className="footdicon">{contactDetail?.Tiktok || "AI Benchmark"}</p>
                  </Col>
                </>
              )}
            </Row>
          </div>

          <div
            style={{
              marginBottom: "16px",
              borderRadius: "8px",
              padding: "0px 0px 20px 0px",
            }}
          >
            <Row gutter={[16, 24]} align="middle">
              {/* 02-564-6900 */}
              {contactDetail?.Phonenumber_show && (
                <>
                  <Col span={2} xs={3} md={4} lg={2}>
                    <PhoneFilled
                      style={{ fontSize: "30px", color: "#BC224A" }}
                    />
                  </Col>
                  <Col span={22} xs={21} md={20} lg={10}>
                    <p className="topicfoot">Phone</p>
                    <p className="footdicon">{contactDetail?.Phonenumber || "02-564-6900"}</p>
                  </Col>
                </>
              )}

              {/* AI Benchmark */}
              {contactDetail?.facebook_show && (
                <>
                  <Col span={2} xs={3} md={4} lg={2}>
                    <FacebookFilled
                      style={{ fontSize: "30px", color: "#BC224A" }}
                    />
                  </Col>
                  <Col span={22} xs={21} md={20} lg={10}>
                    <p className="topicfoot">Facebook</p>
                    <p className="footdicon">{contactDetail?.facebook || "AI Benchmark"}</p>
                  </Col>
                </>
              )}
            </Row>
          </div>
        </Col>

        {/* Column 2: Map */}
        <Col xs={24} md={12} style={{ marginBottom: "20px" }}>
          <Col>
            <div className="task-header">
              <span className="red-bar"></span>
              <p
                className="detail-title"
                style={{
                  textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                  color: "#052240",
                  marginBottom: "0px",
                  fontFamily: "IBM Plex Sans Thai",
                }}
              >
                {t("Location")}
              </p>
            </div>
          </Col>

          <Col>
            <div
              style={{ display: "block", margin: "auto", textAlign: "center" }}
            >
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3869.973576927534!2d100.59874432509623!3d14.078737136348076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x311d7df51d35b21f%3A0xe360f3615838539c!2sNational%20Electronics%20and%20Computer%20Technology%20Center%20(NECTEC)!5e0!3m2!1sen!2sth!4v1760167713043!5m2!1sen!2sth" loading="lazy" className="footlocation" aria-hidden="false"></iframe>
            </div>
          </Col>
        </Col>
      </Row>
    </div>
  );
};

export default Confooter;
